/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
//import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import store from '@/store/'
import { db } from '@/firebase'
import Meta from 'vue-meta'

// Routes

function getRoutesNegocio(host) {
  return db.collection('negocios').where('dominios', 'array-contains', host)
    .get()
    .then((doc) => {

      var routes;
      if (doc.size > 0) {
        var neg = {
          ...doc.docs[0].data(),
          id: doc.docs[0].id
        }

        store.commit("propio/setNegocioPropio", neg.id);
        store.commit("propio/setNegocioPropioObj", neg);
        let aux = require('./' + neg.web.router + '.router.js');
        routes = aux.routes
      } else {
        let aux = require('./funeat.router.js');
        routes = aux.routes
      }
      return routes;
    })
}

Vue.use(Router)
var routes;
var host = location.hostname;

switch (host) {
  case 'funeat.com':
  case 'localhos':
    let aux = require('./funeat.router.js');
    routes = aux.routes
    break;

  default:
    routes = getRoutesNegocio(host);

    break;
}

var router = async () => {
  var r = new Router({
    mode: 'history',
    routes: await routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }
      if (to.hash) {
        return { selector: to.hash }
      }
      return { x: 0, y: 0 }
    }
  })
  r.beforeEach((to, from, next) => {
    if (store.state.app.loading) {
      store.watch(
        (state) => store.state.app.loading,
        (value) => {
          if (value === false) {
            proceed(to, from, next);
          }
        }
      )
    } else {
      proceed(to, from, next);
    }
  })
  function proceed(to, from, next) {
    if (to.fullPath == '/inicio-sesion') {
      beforeEnterAuth(to, from, next);
    }
    //document.title = to.name;
    store.commit('app/setTitle', to.name);
    if (to.meta.logged && !store.state.auth.isLogged) {
      next({ path: '/inicio-sesion' });
    } else {
      if (to.meta.role) {
        if (store.state.loaded && (to.meta.role !== store.state.authModule.role)) {
          next({ path: '/about' });
          return;
        }
      }
      store.dispatch("app/cerrarModales")
      store.commit('snackbar/reset')
      next();
    }
  }


  const beforeEnterAuth = (to, from, next) => {
    if (store.state.auth.isLogged) {
      next({ path: '/' });
    } else {
      next();
    }
  };

  return r;
}

export default router
